import { TAreas } from 'src/constants/lead/leadTypes';
import { TStoreAreas } from 'src/interfaces/store';

/**
 * @description Get the isWspAvailable for the area
 * @param area - The area to get the isWspAvailable for
 * @param areas - The areas to search in
 * @returns The isWspAvailable for the area
 */

export const isWhatsappAvaible = ({
    area,
    areas,
}: {
    area: TAreas;
    areas: TStoreAreas[];
}): boolean => {
    if (!area || !areas) return false;
    return !!areas.find((item) => item.name === area && item.isWspAvailable);
};
